// extracted by mini-css-extract-plugin
export default {"text":"AskZoeLoading_text__AJt51","ellipsis":"AskZoeLoading_ellipsis__lRyOY"};